import { useQuery } from '@apollo/client';

import DiscoveryCollectionsQuery from 'bundles/browse/components/DiscoveryCollectionsQuery.graphql';
import type {
  DiscoveryCollectionsQuery as DiscoveryCollectionsQueryData,
  DiscoveryCollectionsQueryVariables,
} from 'bundles/browse/components/__generated__/DiscoveryCollectionsQuery';
import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';
import { queryErrorHandler } from 'bundles/unified-seo-content-common/utils';

export type ReturnValues = {
  loadingRecommendations: boolean;
  recommendationCollections: Array<DiscoveryCollection | null>;
};

const useDiscoveryCollectionsRecs = (discoveryCollectionSetId: string): ReturnValues => {
  const [contextType, contextId] = discoveryCollectionSetId.split('~');
  const { loading, data } = useQuery<DiscoveryCollectionsQueryData, DiscoveryCollectionsQueryVariables>(
    DiscoveryCollectionsQuery,
    {
      variables: {
        contextType,
        contextId,
      },
      ssr: false,
      skip: !contextId || !contextType,
      errorPolicy: 'all',
      context: { clientName: 'gatewayGql' },
      onError: queryErrorHandler({ extraMessage: 'Error fetching discovery collections data' }),
    }
  );

  return {
    recommendationCollections: data?.DiscoveryCollections?.queryCollections || [],
    loadingRecommendations: loading,
  };
};

export default useDiscoveryCollectionsRecs;
